import "./../insGridPage.scss";
import styles from "./insPacingPlans.module.scss";
import { AuxBadge, AuxButton, AuxGridColumnType } from "@blk/aladdin-react-components-es";
import { AuxBadgeStyleEnum, AuxButtonSizeEnum } from "@blk/aladdin-web-components";
import React, { Fragment } from "react";
import { useDispatch } from "react-redux";
import { insPacingPlansStateId } from "common/constants";
import { exportName } from "common/constants/exportName";
import { getCommitmentPacingPageUrl, getPortfolioCashflowProjectionsPageUrl } from "common/constants/route-helpers";
import { InsGridWidget } from "components";
import { CustomColumnType } from "components/widgets/grid/grid-column-types";
import usePacingPlansApi from "./usePacingPlansApi";
import { InsDeletePacingPlanAction } from "./insDeletePacingPlanAction";
import usePageTitle from "hooks/use-page-title";
import { language } from "language/default";
import { setSelectedRowsState } from "store/grids";
import { push } from "connected-react-router";
import { openModal } from "store/modal";
import { ModalName } from "components/modal/types";
export const handleDeletePacingPlanButtonClicked = (dispatch) => {
    dispatch(setSelectedRowsState({
        id: insPacingPlansStateId,
        selectedRows: []
    }));
};
export const handleCreatePacingPlanClick = (dispatch) => {
    dispatch(openModal({
        content: {
            id: "pacing-plan-creation",
            modalName: ModalName.PacingPlanCreation
        },
        title: language.en.modal.pacingPlanCreation.modalTitle,
        type: "action"
    }));
};
const usePacingPlansColumns = (dispatch) => [
    {
        field: "checkboxCol",
        floatingFilter: false,
        headerCheckboxSelection: false,
        headerName: " ",
        type: AuxGridColumnType.AUX_CHECKBOX_COLUMN,
        width: 32
    },
    { field: "Id", hide: true, lockVisible: true },
    {
        cellRenderer: (params) => {
            const handleLinkClick = () => {
                const portfolioId = params.data?.PortfolioId;
                if (portfolioId) {
                    dispatch(push({
                        pathname: getCommitmentPacingPageUrl(portfolioId),
                        state: { pacingPlanId: params.data?.Name }
                    }));
                }
            };
            return React.createElement("div", { className: styles.cellRenderer__nameContainer },
                React.createElement("span", { className: styles.cellRenderer__link, onClick: (e) => {
                        e.stopPropagation();
                        handleLinkClick();
                    } }, params.value),
                params.data?.IsDefault &&
                    React.createElement(AuxBadge, { badgeStyle: AuxBadgeStyleEnum.NEUTRAL, value: language.en.commitmentPacing.default }));
        },
        enableRowGroup: true,
        field: "Title",
        headerName: "Name",
        type: CustomColumnType.AUX_TEXT_COLUMN,
        width: 450
    },
    {
        enableRowGroup: true,
        field: "PortfolioNameOrId",
        headerName: "Portfolio",
        sort: "asc",
        type: CustomColumnType.AUX_TEXT_COLUMN,
        width: 250
    },
    {
        enableRowGroup: false,
        field: "EndNavTarget",
        headerName: "End NAV Target",
        type: CustomColumnType.InsMoneyColumn,
        width: 150
    },
    {
        enableRowGroup: false,
        field: "StartDate",
        headerName: "Plan Start Date",
        hide: true,
        skipExcelExport: true,
        type: CustomColumnType.InsDateColumn,
        width: 150
    },
    {
        cellClass: "center-aligned-cell",
        enableRowGroup: false,
        field: "PortfolioId",
        filter: false,
        headerName: "View In Portfolio",
        skipExcelExport: true,
        sortable: false,
        type: [CustomColumnType.InsDatapointLinkColumn],
        width: 120
    }
];
export const InsPacingPlans = () => {
    usePageTitle(`${language.en.common.titles.pacingPlans} - ${language.en.common.titles.base}`);
    const dispatch = useDispatch();
    const apiResponse = usePacingPlansApi();
    const { data, querystate, refresh } = apiResponse;
    const pacingPlansData = data;
    const columnsDefinition = usePacingPlansColumns(dispatch);
    const linksMapping = [
        {
            customOnClick: (params) => {
                const portfolioId = params.data?.PortfolioId;
                if (portfolioId) {
                    dispatch(push({
                        pathname: getCommitmentPacingPageUrl(portfolioId),
                        state: { pacingPlanId: params.data?.Name }
                    }));
                }
            },
            field: "Title",
            id: "pacing-plan-name-link",
            params: [],
            path: ""
        },
        {
            customOnClick: (params) => {
                const portfolioId = params.data?.PortfolioId;
                const workspaceId = params.data?.WorkspaceId;
                if (portfolioId) {
                    dispatch(push({
                        pathname: getPortfolioCashflowProjectionsPageUrl(portfolioId, workspaceId),
                        state: { pacingPlanId: params.data?.Name }
                    }));
                }
            },
            field: "PortfolioId",
            icon: "eye",
            id: "PortfolioId",
            params: [],
            path: ""
        }
    ];
    return React.createElement(React.Fragment, null,
        React.createElement("div", { className: styles.description },
            React.createElement("div", { className: styles.description__title }, language.en.commitmentPacing.admin.description.title),
            React.createElement("div", { className: styles.description__text }, language.en.commitmentPacing.admin.description.text)),
        React.createElement(InsGridWidget, { suppressExcelExport: false, exportExcelName: exportName.PacingPlans, stateId: insPacingPlansStateId, widgetId: insPacingPlansStateId, applyColumnsAutosize: false, columnDefs: columnsDefinition, rowSelectedHandler: ((e) => {
                dispatch(setSelectedRowsState({
                    id: insPacingPlansStateId,
                    selectedRows: e.api.getSelectedRows().map((row) => row.Name)
                }));
            }), rowData: pacingPlansData, selectionMode: "multiple", refreshAction: refresh, queryState: querystate, dataMenu: [], context: { linksMapping }, allowTags: false, headerLeft: React.createElement(React.Fragment, null), additionalNodes: [
                React.createElement(Fragment, { key: "pacing-plans-additional-nodes" },
                    React.createElement(InsDeletePacingPlanAction, { isDisabled: false }),
                    React.createElement(AuxButton, { size: AuxButtonSizeEnum.SMALL, onClick: () => handleCreatePacingPlanClick(dispatch), label: language.en.modal.pacingPlanCreation.title }))
            ] }));
};
